/**
 * Textos do recebimento automático (plano, seção 6). Um só lugar, fácil de
 * revisar — nenhuma tela escreve taxa, prazo ou limite direto: tudo recebe
 * o `PaymentPricing` de `usePaymentPricing()` (T1.6) por parâmetro.
 */
export * from './about';
export * from './activation';
export * from './charge';
export * from './checkout';
export * from './entry-points';
export * from './faq';
export * from './help-articles';
export * from './receivables';
export * from './settings';
export * from './shared';
